module.exports = __webpack_public_path__ + "static/media/messenger.0ce44106.png";